import { defineComponent, createElementBlock, openBlock, normalizeClass, createElementVNode, renderSlot, normalizeStyle } from "vue";
import { _ as _export_sfc } from "./chunks/_plugin-vue_export-helper.js";
const LOADER_TYPES = {
  rectangle: "rectangle",
  circle: "circle"
};
const LOADER_CSS_CLASSES = {
  [LOADER_TYPES.rectangle]: "rounded",
  [LOADER_TYPES.circle]: "rounded-full"
};
const SHIMMER_COLOR = "#ffffff";
const isHexColor = (hexColor) => {
  const hex = hexColor.replace("#", "");
  return typeof hexColor === "string" && hexColor.startsWith("#") && hex.length === 6 && !isNaN(Number("0x" + hex));
};
const hexToRgb = (hex) => {
  var _a;
  return `${(_a = hex.match(/\w\w/g)) == null ? void 0 : _a.map((x) => +`0x${x}`)}`;
};
const _sfc_main = defineComponent({
  name: "PSkeletonLoader",
  props: {
    type: {
      type: String,
      default: LOADER_TYPES.rectangle,
      validator(value) {
        return Object.values(LOADER_TYPES).includes(value);
      }
    },
    bgClass: {
      type: String,
      default: "bg-p-gray-30"
    },
    cssClass: {
      type: String,
      default: ""
    },
    shimmerColor: {
      type: String,
      default: SHIMMER_COLOR
    }
  },
  data() {
    return {
      LOADER_TYPES
    };
  },
  computed: {
    shimmerStyle() {
      const rgb = isHexColor(this.shimmerColor) ? hexToRgb(this.shimmerColor) : SHIMMER_COLOR;
      return {
        backgroundImage: `linear-gradient(90deg, rgba(${rgb}, 0) 0%, rgba(${rgb}, 0.2) 20%, rgba(${rgb}, 0.5) 60%, rgba(${rgb}, 0))`
      };
    },
    loaderClass() {
      return this.cssClass ? this.cssClass : LOADER_CSS_CLASSES[this.type];
    }
  }
});
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: normalizeClass([_ctx.bgClass, _ctx.loaderClass, "relative overflow-hidden"])
  }, [
    createElementVNode("div", {
      class: "shimmer absolute bottom-0 left-0 right-0 top-0",
      style: normalizeStyle(_ctx.shimmerStyle)
    }, null, 4),
    renderSlot(_ctx.$slots, "default", {}, void 0, true)
  ], 2);
}
const PSkeletonLoader = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__scopeId", "data-v-3d77f34f"]]);
export {
  PSkeletonLoader as default
};
